import { ListType } from 'crono-fe-common/types/list';
import { DashboardTabType } from './dashboardTabType';

const TAB_BY_LIST_TYPE: Partial<Record<ListType, DashboardTabType>> = {
  [ListType.Account]: 'Company',
  [ListType.Prospect]: 'Contact',
  [ListType.Lead]: 'Lead',
};

/** The Lists page tab that shows lists of this type, if the Lists page shows them at all. */
export const getListsPageTab = (type: ListType | null | undefined) =>
  type ? TAB_BY_LIST_TYPE[type] : undefined;
